// Files stay on this device until upload succeeds or the user discards them.
// Separate accounts/companies never share the recovery list.
const memory = new Map();
const keyFor = (scope, expenseId) => `${scope}:${expenseId}`;
const open = () => new Promise((resolve, reject) => {
  const request = indexedDB.open('rotaflex-frota-pending', 2);
  request.onupgradeneeded = () => {
    const store = request.result.objectStoreNames.contains('uploads')
      ? request.transaction.objectStore('uploads')
      : request.result.createObjectStore('uploads', { keyPath: 'key' });
    if (!store.indexNames.contains('scope')) store.createIndex('scope', 'scope');
  };
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
  request.onblocked = () => reject(new Error('Armazenamento local indisponível.'));
});
async function transaction(mode, operation) {
  const db = await open();
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction('uploads', mode);
      const request = operation(tx.objectStore('uploads'));
      tx.oncomplete = () => resolve(request.result);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
  } finally { db.close(); }
}
export async function savePendingAttachments(scope, expenseId, files) {
  const key = keyFor(scope, expenseId);
  const entry = { key, scope, expenseId, files, durable: true };
  memory.set(key, entry);
  try {
    await transaction('readwrite', store => files.length ? store.put(entry) : store.delete(key));
    return true;
  } catch { entry.durable = false; return false; }
}
export async function listPendingAttachments(scope) {
  let saved = [];
  try { saved = await transaction('readonly', store => store.index('scope').getAll(scope)); } catch { /* Session recovery still works when browser storage is unavailable. */ }
  const entries = new Map(saved.filter(entry => entry.scope === scope).map(entry => [entry.key, entry]));
  for (const [key, entry] of memory) if (entry.scope === scope) entries.set(key, entry);
  return [...entries.values()].filter(entry => entry.files.length > 0);
}
export async function loadPendingAttachments(scope, expenseId) {
  return (await listPendingAttachments(scope)).find(entry => String(entry.expenseId) === String(expenseId)) || { files: [], durable: true };
}
